import { adminTrpc } from '@bitbot/api';
import { createStore } from 'hox';
import { useEffect, useMemo, useState } from 'react';

export const [useInviteClaim, InviteClaimProvider] = createStore(() => {
  const claimReward =
    adminTrpc.claimReward.claimEveryDayReward.useMutation();
  const [currentGiftId, setCurrentGiftId] = useState(0);
  const {
    data: claim20USDCStatus,
    isLoading: isLoadingClaim20USDCStatus,
    refetch: refetchClaim20USDCStatus,
  } = adminTrpc.claimReward.getClaim20USDCStatus.useQuery({
    giftId: currentGiftId,
  });
  const giftsQuery = adminTrpc.claimReward.getAllGifts.useQuery();
  const everyDayRewardTaskStatusQuery =
    adminTrpc.claimReward.getEveryDayRewardTaskStatus.useQuery(undefined, {
      enabled: !!currentGiftId,
    });
  const everyDayRewardStatusQuery =
    adminTrpc.claimReward.getClaimEveryDayRewardStatus.useQuery(
      {
        giftId: currentGiftId,
      },
      {
        enabled: !!currentGiftId,
      },
    );
  const claimEveryDayReward =
    adminTrpc.claimReward.claimEveryDayReward.useMutation();

  // 每日任务状态
  const everyDayRewardTaskStatus = useMemo(() => {
    if (!everyDayRewardTaskStatusQuery.data) {
      return null;
    }
    return everyDayRewardTaskStatusQuery.data;
  }, [everyDayRewardTaskStatusQuery.data]);
  // 每日任务领取状态
  const everyDayRewardStatus = useMemo(() => {
    if (!everyDayRewardStatusQuery.data) {
      return null;
    }
    return everyDayRewardStatusQuery.data;
  }, [everyDayRewardStatusQuery.data]);

  // 所有礼物
  const allGifts = useMemo(() => {
    if (!giftsQuery.data) {
      return [];
    }
    return giftsQuery.data;
  }, [giftsQuery.data]);
  useEffect(() => {
    if (allGifts.length > 0) {
      setCurrentGiftId(allGifts[0].id);
    }
  }, [allGifts]);
  // 当前礼物
  const currentGift = useMemo(() => {
    if (!giftsQuery.data) {
      return null;
    }
    return allGifts.find(item => item.id === currentGiftId);
  }, [allGifts, currentGiftId]);

  const { data: userTradeAmount } =
    adminTrpc.claimReward.getUserTradeAmount.useQuery(
      {
        giftId: currentGiftId,
      },
      {
        enabled: currentGiftId > 0,
      },
    );

  const claim20USDC = adminTrpc.claimReward.claim20USDC.useMutation({
    onSuccess: () => {
      refetchClaim20USDCStatus();
    },
  });

  const cashBackProgress = useMemo(() => {
    return userTradeAmount ? (Number(userTradeAmount) / 2000) * 100 : 0;
  }, [userTradeAmount]);
  const gasCardQuery = adminTrpc.claimReward.getGasFeeCard.useQuery(
    {
      giftId: currentGiftId,
    },
    {
      enabled: !!currentGiftId,
    },
  );
  const gasCardData = useMemo(() => {
    if (!gasCardQuery.data) {
      return null;
    }
    return gasCardQuery.data;
  }, [gasCardQuery.data]);

  const claim10USD = adminTrpc.claimReward.claim10USD.useMutation({
    onSuccess: () => {
      gasCardQuery.refetch();
    },
  });
  return {
    claimReward,
    allGifts,
    giftsQuery,
    currentGift,
    currentGiftId,
    setCurrentGiftId,
    userTradeAmount,
    claim20USDCStatus,
    isLoadingClaim20USDCStatus,
    claim20USDC,
    cashBackProgress,
    everyDayRewardStatus,
    everyDayRewardTaskStatus,
    claimEveryDayReward,
    gasCardData,
    gasCardQuery,
    claim10USD,
  };
});
